import { TABLE_DIVIDER_WIDTH } from '@/features/shared/components/tableSystem/tableConstants';
import type { Theme } from '@/ui/primitives';

export const resolveTableDividerColor = (muiTheme: Theme): string => muiTheme.palette.divider;

export const buildTableDividerPseudoSx = (
  position: 'top' | 'bottom',
): Record<string, string | number | ((muiTheme: Theme) => string)> => ({
  content: '""',
  position: 'absolute',
  left: 0,
  right: 0,
  [position]: 0,
  height: '1px',
  backgroundColor: (muiTheme: Theme) => resolveTableDividerColor(muiTheme),
  transform: `scaleY(${String(TABLE_DIVIDER_WIDTH)})`,
  transformOrigin: position === 'top' ? 'top center' : 'bottom center',
  pointerEvents: 'none',
});
